
import './App.css';
import React, { useEffect, useState } from 'react';
import { forceRerender } from './utils/cacheBuster';

import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Navbar from './components/Navbar'
import Layout from './components/Layout';
import Services from './components/Services'
import Contact from './components/Contact';
import Privacy from './components/Privacy';
import Learn from './components/Learn';
import Portfolio from './components/Portfolio';
import Footer from './components/Footer';
import PromptManager from './components/PromptManager';
import Shop from './components/Shop'
import ShopSnapCharms from './components/ShopSnapCharms'
import ShopSports from './components/ShopSports'
import ShopLocals from './components/ShopLocals'
import { CartProvider } from './context/CartContext';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import ProductDetail from './components/ProductDetail';
import Success from './components/Success';
import Cancel from './components/Cancel';
import OrderComplete from './components/OrderComplete';
import Shipping from './components/Shipping';
import ScrollToTop from './components/ScrollToTop';
import Legal from './components/Legal';
import TermsAndConditions from './components/TermsAndConditions';

function App() {
  // Force re-render in development mode to prevent caching
  const [cacheBuster] = useState(() => forceRerender());

  // Clear any cached data in development
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // Clear localStorage cache (but preserve cart data)
      const cartData = localStorage.getItem('cart');
      const customerData = localStorage.getItem('customerInfo');
      const shippingData = localStorage.getItem('shippingAddress');
      const orderData = localStorage.getItem('orderInfo');
      
      // Clear everything except cart-related data
      localStorage.clear();
      
      // Restore cart data
      if (cartData) localStorage.setItem('cart', cartData);
      if (customerData) localStorage.setItem('customerInfo', customerData);
      if (shippingData) localStorage.setItem('shippingAddress', shippingData);
      if (orderData) localStorage.setItem('orderInfo', orderData);
      
      console.log('Development mode: Cache cleared, cart preserved');
    }
  }, [cacheBuster]);

  return (
   <>
   <CartProvider>
      <ScrollToTop />
        <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/promptmanager" element={<PromptManager />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/snapcharms" element={<ShopSnapCharms />} />
              <Route path="/shop/sports" element={<ShopSports />} />
              <Route path="/shop/locals" element={<ShopLocals />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/success" element={<Success />} />
              <Route path="/cancel" element={<Cancel />} />
              <Route path="/order-complete" element={<OrderComplete />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/tc" element={<TermsAndConditions />} />
            </Routes>
        </Layout>
      <Footer/>
    </CartProvider>
   </>
  );
}

export default App;
